import React from 'react'

import {
  Accordion,
  AutenticacaoContainer,
  Botao,
  ConteudoBotao,
  IconeAdicionar,
  IconeDeEdicaoDeUpload,
  IconeLixeira,
  Spacer,
  Tooltip,
  Visao
} from 'src/componentes'
import { DisciplinaTurmaCertificacao, ModuloTurmaCertificacao } from 'src/tipos'

import {
  BotaoIcone,
  ContainerBotao,
  ContainerBotaoIcone,
  ContainerDisciplinas,
  ContainerGrade,
  ConteudoBotaoEditarModulo,
  ListaModulos,
  Tabela,
  TituloModulo
} from '../../styles'
import { DisciplinaCertificacaoVinculada } from '../../tipos'
import { ModalEditarModuloCertificacaoRef } from '../modal-editar-modulo/tipos'
import { ModalIncluirDisciplinaCertificacaoRef } from '../modal-incluir-disciplina/tipos'
import { ModalIncluirModuloCertificacaoRef } from '../modal-incluir-modulo/tipos'
import { ModalVincularDisciplinaModuloRef } from '../modal-vincular-disciplina-modulo/tipos'

type ListaModuloDisciplinaProps = {
  modulos: ModuloTurmaCertificacao[]
  disciplinas: DisciplinaCertificacaoVinculada[]
  usuarioId: string
  divisao: string
  modalIncluirModuloRef: React.RefObject<ModalIncluirModuloCertificacaoRef>
  modalIncluirDisciplinaRef: React.RefObject<ModalIncluirDisciplinaCertificacaoRef>
  modalExcluirDisciplinaRef: React.RefObject<ModalIncluirDisciplinaCertificacaoRef>
  modalEditarModuloRef: React.RefObject<ModalEditarModuloCertificacaoRef>
  modalDisciplinaModuloRef: React.RefObject<ModalVincularDisciplinaModuloRef>
  modalDesvincularDisciplinaref: React.RefObject<ModalVincularDisciplinaModuloRef>
  defineIndexModulo: (index: number) => void
}

export const ListaModuloDisciplina: React.FC<ListaModuloDisciplinaProps> = ({
  modulos,
  disciplinas,
  divisao,
  modalIncluirModuloRef,
  modalIncluirDisciplinaRef,
  modalExcluirDisciplinaRef,
  modalEditarModuloRef,
  modalDisciplinaModuloRef,
  modalDesvincularDisciplinaref,
  defineIndexModulo
}) => {
  const { visao } = AutenticacaoContainer.useContainer()

  const abrirModalEditarDisciplina = (
    disciplina: DisciplinaTurmaCertificacao,
    indexDisciplina: number
  ) => {
    modalIncluirDisciplinaRef?.current?.abrir({
      ...disciplina,
      indexDisciplina
    })
  }

  const abrirModalEditarDisciplinaModulo = (
    disciplina: DisciplinaTurmaCertificacao,
    indexModulo: number,
    indexDisciplina: number
  ) => {
    modalDisciplinaModuloRef?.current?.abrir(
      disciplina,
      indexModulo,
      indexDisciplina
    )
  }

  const abrirModalDesvincularDisciplina = (
    disciplina: DisciplinaTurmaCertificacao,
    indexModulo: number,
    indexDisciplina: number
  ) => {
    modalDesvincularDisciplinaref?.current?.abrir(
      disciplina,
      indexModulo,
      indexDisciplina
    )
  }

  const abrirModalExcluirDisciplina = (
    disciplina: DisciplinaTurmaCertificacao,
    indexDisciplina: number
  ) => {
    modalExcluirDisciplinaRef?.current?.abrir(disciplina, indexDisciplina)
  }

  const isParceiro = visao === Visao.ParceiroCertificacao

  return (
    <>
      {divisao && (
        <ContainerGrade>
          <Accordion
            titulo={`Divisão da Turma - ${
              divisao === 'Modulo' ? 'Módulo' : 'Disciplina'
            }`}
            inativo={false}
            iniciarAberto={true}
          >
            {isParceiro && (
              <BotaoIcone
                id="btn_adicionar_modulo"
                type="button"
                onClick={() => {
                  divisao === 'Modulo'
                    ? modalIncluirModuloRef?.current?.abrir()
                    : modalIncluirDisciplinaRef?.current?.abrir()
                }}
              >
                {IconeAdicionar} Incluir{' '}
                {divisao === 'Modulo' ? 'Módulo' : 'Disciplina'}
              </BotaoIcone>
            )}
            <Spacer padding="5px 5px" />
            {divisao === 'Modulo' ? (
              <>
                {modulos?.map((modulo, moduloIdx) => (
                  <>
                    <ListaModulos>
                      <TituloModulo>{`${moduloIdx + 1}. ${
                        modulo.nome
                      }`}</TituloModulo>
                      {divisao === 'Modulo' && (
                        <>
                          {modulos.length >= 1 && isParceiro ? (
                            <ContainerBotao>
                              <div style={{ display: 'flex' }}>
                                <Botao
                                  type="button"
                                  tema="Link"
                                  elemento={
                                    <ConteudoBotaoEditarModulo>
                                      {IconeDeEdicaoDeUpload}
                                      Editar Módulo
                                    </ConteudoBotaoEditarModulo>
                                  }
                                  onClick={() => {
                                    modalEditarModuloRef?.current?.abrir(modulo)
                                    defineIndexModulo(moduloIdx)
                                  }}
                                />
                                <Botao
                                  type="button"
                                  tema="Link"
                                  elemento={
                                    <ConteudoBotao>
                                      {IconeAdicionar} Vincular Disciplina
                                    </ConteudoBotao>
                                  }
                                  onClick={() => {
                                    modalDisciplinaModuloRef?.current?.abrir()
                                    defineIndexModulo(moduloIdx)
                                  }}
                                />
                              </div>
                              {/* )} */}
                            </ContainerBotao>
                          ) : null}
                        </>
                      )}
                    </ListaModulos>
                    {/* prettier-ignore */}
                    {modulo.disciplinasMCertificacao?.some(d => !d.deletado) ? (
                      <ContainerDisciplinas>
                        <Tabela>
                          <thead>
                            <tr>
                              <th align="center">Disciplina</th>
                              <th align="center">Professor</th>
                              <th align="center">Carga Horária</th>
                              <th align="center"></th>
                              <th align="center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {modulo.disciplinasMCertificacao.map(
                              (disciplina, idx) =>
                                !disciplina.deletado && (
                                  <tr key={`vincular-${idx}`}>
                                    <td align="center">{disciplina.nome}</td>
                                    <td align="center">
                                      {disciplina
                                        ?.professorDisciplinasModuloCertificacao?.[0]
                                        ?.nomeProfessor ?? ''}
                                    </td>
                                    <td align="center">
                                      {disciplina.cargaHoraria}
                                    </td>
                                    {isParceiro && (
                                      <>
                                        <td>
                                          <ContainerBotaoIcone>
                                            <button
                                              type="button"
                                              data-tip="Editar"
                                              data-for={`tooltip-editar-${idx}`}
                                              onClick={() => {
                                                abrirModalEditarDisciplinaModulo(
                                                  disciplina as DisciplinaTurmaCertificacao,
                                                  moduloIdx,
                                                  idx
                                                )
                                              }}
                                            >
                                              {IconeDeEdicaoDeUpload}
                                            </button>
                                            <Tooltip
                                              id={`tooltip-editar-${idx}`}
                                              place="bottom"
                                              offset={{ top: 10 }}
                                            />
                                          </ContainerBotaoIcone>
                                        </td>
                                        <td>
                                          <ContainerBotaoIcone>
                                            <button
                                              type="button"
                                              data-tip="Desvincular"
                                              data-for={'tooltip-lixeira'}
                                              onClick={() => {
                                                defineIndexModulo(moduloIdx)
                                                abrirModalDesvincularDisciplina(
                                                  disciplina as DisciplinaTurmaCertificacao,
                                                  moduloIdx,
                                                  idx
                                                )
                                              }}
                                            >
                                              {IconeLixeira}
                                            </button>
                                            <Tooltip
                                              id={'tooltip-lixeira'}
                                              place="bottom"
                                              offset={{ top: 10 }}
                                            />
                                          </ContainerBotaoIcone>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Tabela>
                      </ContainerDisciplinas>
                    ) : null}

                    <Spacer padding="5px 5px" />
                  </>
                ))}
              </>
            ) : (
              <>
                {disciplinas?.length > 0 ? (
                  <>
                    {disciplinas?.some(d => !d.deletado) ? (
                      <ContainerDisciplinas>
                        <Tabela>
                          <thead>
                            <th align="center">Disciplina</th>
                            <th align="center">Professor</th>
                            <th align="center">Carga Horária</th>
                            <th align="center"></th>
                            <th align="center"></th>
                          </thead>
                          <tbody>
                            {disciplinas.map(
                              (disciplina, disciplinaIdx) =>
                                !disciplina.deletado && (
                                  <tr key={`vincular-${disciplinaIdx}`}>
                                    <td align="center">{disciplina.nome}</td>
                                    <td align="center">
                                      {
                                        disciplina
                                          ?.professorDisciplinasCertificacao[0]
                                          .nomeProfessor
                                      }
                                    </td>
                                    <td align="center">
                                      {disciplina.cargaHoraria}
                                    </td>
                                    {isParceiro && (
                                      <>
                                        <td>
                                          <ContainerBotaoIcone>
                                            <button
                                              type="button"
                                              data-tip="Editar"
                                              data-for={`tooltip-editar-${disciplinaIdx}`}
                                              onClick={() => {
                                                abrirModalEditarDisciplina(
                                                  disciplina as DisciplinaTurmaCertificacao,
                                                  disciplinaIdx
                                                )
                                              }}
                                            >
                                              {IconeDeEdicaoDeUpload}
                                            </button>
                                            <Tooltip
                                              id={`tooltip-editar-${disciplinaIdx}`}
                                              place="bottom"
                                              offset={{ top: 10 }}
                                            />
                                          </ContainerBotaoIcone>
                                        </td>
                                        <td>
                                          <ContainerBotaoIcone>
                                            <button
                                              type="button"
                                              data-tip="Desvincular"
                                              data-for={'tooltip-lixeira'}
                                              onClick={() => {
                                                abrirModalExcluirDisciplina(
                                                  disciplina as DisciplinaTurmaCertificacao,
                                                  disciplinaIdx
                                                )
                                              }}
                                            >
                                              {IconeLixeira}
                                            </button>
                                            <Tooltip
                                              id={'tooltip-lixeira'}
                                              place="bottom"
                                              offset={{ top: 10 }}
                                            />
                                          </ContainerBotaoIcone>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                )
                            )}
                          </tbody>
                        </Tabela>
                      </ContainerDisciplinas>
                    ) : null}
                  </>
                ) : null}
              </>
            )}
          </Accordion>
        </ContainerGrade>
      )}
    </>
  )
}
